

























import Vue, { PropType } from "vue";

declare global {
  interface Window {
    cancelScreenLock: any;
  }
}

export interface ScreenLockProps {
  isBusy: boolean;
  updateIsBusy: any;
}

export interface ScreenLockData {
  circleSize: number;
  radius: number;
  strokeWidth: number;
  timeoutIds: number[];
  cancel: boolean;
}

export default Vue.extend({
  name: "vc-screen-lock",
  props: {
    isBusy: {
      type: Boolean as PropType<ScreenLockProps["isBusy"]>,
      default: false
    },
    //mutationsToProps
    updateIsBusy: {
      type: Function as PropType<ScreenLockProps["updateIsBusy"]>,
      default: () => {}
    }
  },
  data(): ScreenLockData {
    return {
      circleSize: 50,
      radius: 20,
      strokeWidth: 5,
      timeoutIds: [],
      cancel: false
    };
  },
  computed: {
    // svg の描画領域 (vuetify の git を参考)
    viewBoxSize(): number {
      return this.radius / (1 - Number(this.strokeWidth) / +this.circleSize);
    }
  },
  created() {
    // 使用例：ScreenLockを表示させたくないaタグ等に対して、onclick="window.cancelScreenLock()"を付与する
    window.cancelScreenLock = this.cancelScreenLock;
  },
  mounted() {
    // ページ遷移中の待ち時間が一定を超えたらローダーを表示させる
    // beforeunloadEvent（同窓ページ遷移時を想定）にローダー表示処理を行う
    // 事前にcancelScreenLockが実行済みならローダーは表示しない
    window.addEventListener("beforeunload", e => {
      if (this.cancel) {
        this.cancel = false;
        this.clearScreenLock();
      } else {
        this.setScreenLock();
      }
    });

    // Edge版ICE環境ではICE.callIce()のlocation.href="callIce://xxx"が実行されるとbeforeunloadEventが発火しローダーが表示されてしまう
    // そのためcallIceをカスタムイベントであらかじめ検知して、先にcancelScreenLockしローダーの表示を防ぐ
    // IE版ICE環境ではcallIceEventは発火しない
    window.addEventListener("callIce", this.cancelScreenLock);

    // Safariなど一部ブラウザのブラウザバックではtimeoutIdsが保持されローダーが表示されてしまうため、pageshow時にclearScreenLockする
    window.addEventListener("pageshow", this.clearScreenLock);
  },
  methods: {
    // ローダーを表示する処理を1秒後に実行するタイマーを設定
    setScreenLock() {
      let timeoutId = window.setTimeout(() => {
        this.updateIsBusy(true);
      }, 1000); // 1秒という時間はRAILモデル（ https://web.dev/rail/ ）を基準に設定

      // 連打対応で複数のタイマーを保管する配列を用意
      this.timeoutIds.push(timeoutId);
    },

    // timeoutIdsをリセットし、ローダーが表示されていれば非表示にする
    clearScreenLock() {
      // 連打でtimeoutIdsに複数処理が入った場合、全てをclearTimeoutしてからtimeoutIdsをリセットする
      this.timeoutIds.forEach(timeoutId => {
        window.clearTimeout(timeoutId);
      });
      this.timeoutIds = [];
      this.updateIsBusy(false);
    },

    // clearScreenLockを行い、次にローダーが表示されるタイミングでローダーが表示されないようにする
    cancelScreenLock() {
      this.cancel = true;
      this.clearScreenLock();
    }
  }
});
